import React, { useState } from "react";
import * as Mui from "@mui/material";
import { themes } from "services/constants";
import { Close } from "@mui/icons-material";
import styled from "styled-components";
import { EligibleEmployeeList } from "./EligibleEmployee";
import { QualifiedMembers } from "./QualifiedMembers";
import { EligibleMetEmployee } from "./EligibleMetEmployee";
import { formBackGroundColor } from "services/constants/Styles";

export const EmployeeDetails = ({
  setOpenSidePeek,
  openSidePeek,
  EmployeeCheck,
  eligibleEmpDetails,
  getEmployeeCount,
  eligibleMetEmployee,
  setEligibleMetEmployee,
  removedEmployees,
  setRemovedEmployees,
  EligibleEmployee,
  QualifiedCheck,
  qualifiedMembersList,
  IncentiveType,
  IncntiveName,
}) => {
  const [doAnyAct, setDoAnyAct] = useState(false);
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Mui.Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenSidePeek(open);
    if (open === false) {
      if (doAnyAct) {
        setDoAnyAct(false);
      }
    }
  };

  return (
    <React.Fragment>
      <Mui.Drawer
        anchor="right"
        open={openSidePeek}
        onClose={toggleDrawer("right", false)}
        PaperProps={{
          sx: {
            width: {
              xs: 450,
              sm: 450,
              md: 700,
              lg: EmployeeCheck ? 700 : 750,
            },
          },
        }}
      >
        <Mui.Grid
          container
          sx={{
            backgroundColor: themes.primaryIndicator,
            padding: 1,
          }}
        >
          <Mui.Grid xs={11}>
            <Mui.Typography
              sx={{
                color: themes.headLine,
                textAlign: "left",
                fontSize: 22,
                paddingTop: 1,
                fontWeight: "bold",
                paddingLeft: 2,
              }}
            >
              {IncntiveName}
            </Mui.Typography>
          </Mui.Grid>

          <Mui.Grid xs={1}>
            <Mui.IconButton
              sx={{
                "&:hover": {
                  backgroundColor: themes.headLine,
                },
                backgroundColor: themes.headLine,
              }}
              onClick={() => {
                setOpenSidePeek(false);
              }}
            >
              <Close sx={{ color: themes.whiteColor }} />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>

        <Mui.Grid sx={{ mr: 2, ml: 2 }}>
          <Mui.Grid
            sx={{
              mt: 2,
              border: `2px solid ${themes.sidebarDivider}`,
              backgroundColor: formBackGroundColor,
              padding: 1,
              borderRadius: 1,
            }}
          >
            <Mui.Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
              {EmployeeCheck
                ? `Eligible Employee : ${EligibleEmployee?.length}`
                : QualifiedCheck
                ? `Eligible Met Employees : ${qualifiedMembersList?.length}`
                : `Incentive Applicable Employees : ${eligibleMetEmployee?.length}`}
            </Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>

        <StyledGrid container>
          <ContentGrid item xs={12}>
            <Mui.Grid container>
              {EmployeeCheck ? (
                <EligibleEmployeeList
                  eligibleEmpDetails={eligibleEmpDetails}
                  getEmployeeCount={getEmployeeCount}
                  EligibleEmployee={EligibleEmployee}
                />
              ) : QualifiedCheck ? (
                <QualifiedMembers qualifiedMembersList={qualifiedMembersList} />
              ) : (
                <EligibleMetEmployee
                  getEmployeeCount={getEmployeeCount}
                  eligibleMetEmployee={eligibleMetEmployee}
                  setEligibleMetEmployee={setEligibleMetEmployee}
                  removedEmployees={removedEmployees}
                  setRemovedEmployees={setRemovedEmployees}
                  IncentiveType={IncentiveType}
                />
              )}
            </Mui.Grid>
          </ContentGrid>
        </StyledGrid>
      </Mui.Drawer>
    </React.Fragment>
  );
};

const StyledGrid = styled(Mui.Grid)`
  height: 80vh;
`;

const ContentGrid = styled(Mui.Grid)`
  width: 80%;
`;
